import { userIsPublic, userIsRegistered } from "~/domains/user/utils/roles";
import type { SalesPartnerStockData } from "~/features/salesPartnerStock/types";
import { getRuntimeConfig } from "~/common/config/runtimeConfig";

export function canSeeBuyFromSalesPartnerButton() {
  return getRuntimeConfig().salesPartnerStockIntegrationEnabled && (userIsPublic() || userIsRegistered());
}

export function salesStockDataSorter(a: SalesPartnerStockData, b: SalesPartnerStockData) {
  // Preferred first, second in stock
  if (a.preferred && !b.preferred) {
    return -1;
  }
  if (!a.preferred && b.preferred) {
    return 1;
  }
  if (a.inStock && !b.inStock) {
    return -1;
  }
  if (!a.inStock && b.inStock) {
    return 1;
  }
  return a.order - b.order;
}
